import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { ArrowLeft, ShieldCheck } from 'lucide-react';

const PrivacyPolicy = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen" style={{ backgroundColor: 'var(--cream-white)' }}>
      {/* Header */}
      <header className="border-b border-gray-200 bg-white">
        <nav className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <h1 
            className="text-2xl font-bold"
            style={{ fontFamily: 'Playfair Display, serif', color: 'var(--charcoal)' }}
          >
            Datenschutzerklärung
          </h1>
          <Button 
            variant="outline"
            onClick={() => navigate('/')}
            className="flex items-center gap-2"
            style={{ borderColor: 'var(--warm-gray)', color: 'var(--charcoal)' }}
          >
            <ArrowLeft className="w-4 h-4" />
            Zurück
          </Button>
        </nav>
      </header>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-6 py-16">
        <div className="flex items-center justify-center mb-8">
          <ShieldCheck className="w-16 h-16" style={{ color: 'var(--warm-sage)' }} />
        </div>

        <div className="prose prose-lg max-w-none" style={{ color: 'var(--charcoal)' }}>
          <p className="text-sm mb-8" style={{ color: 'var(--warm-gray)' }}>
            Stand: Januar 2025
          </p>

          <h2 style={{ fontFamily: 'Playfair Display, serif', color: 'var(--charcoal)', fontSize: '28px', marginBottom: '16px' }}>
            1. Allgemeines
          </h2>
          <p style={{ lineHeight: '1.8', marginBottom: '24px' }}>
            Gestützt auf Artikel 13 der schweizerischen Bundesverfassung und die datenschutzrechtlichen Bestimmungen des Bundes (Datenschutzgesetz, DSG) hat jede Person Anspruch auf Schutz ihrer Privatsphäre sowie auf Schutz vor Missbrauch ihrer persönlichen Daten. Wir halten diese Bestimmungen ein. Persönliche Daten werden streng vertraulich behandelt und weder an Dritte verkauft noch weitergegeben.
          </p>

          <h2 style={{ fontFamily: 'Playfair Display, serif', color: 'var(--charcoal)', fontSize: '28px', marginBottom: '16px' }}>
            2. Verantwortliche Stelle
          </h2>
          <p style={{ lineHeight: '1.8', marginBottom: '24px' }}>
            Verantwortlich für die Datenbearbeitung auf dieser Website ist:<br /><br />
            <strong>Love Luxe</strong><br />
            Zug, Schweiz<br />
            E-Mail: contact@lvluxury.ch<br />
            Telefon: +41 41 543 36 77
          </p>

          <h2 style={{ fontFamily: 'Playfair Display, serif', color: 'var(--charcoal)', fontSize: '28px', marginBottom: '16px' }}>
            3. Erhebung und Verarbeitung personenbezogener Daten
          </h2>
          <p style={{ lineHeight: '1.8', marginBottom: '24px' }}>
            Wir erheben personenbezogene Daten nur dann, wenn Sie uns diese freiwillig mitteilen, beispielsweise durch:
          </p>
          <ul style={{ marginBottom: '24px', paddingLeft: '24px' }}>
            <li style={{ marginBottom: '8px' }}>Kontaktformular-Anfragen</li>
            <li style={{ marginBottom: '8px' }}>Newsletter-Anmeldungen</li>
            <li style={{ marginBottom: '8px' }}>E-Mail-Korrespondenz</li>
            <li style={{ marginBottom: '8px' }}>Produktanfragen</li>
          </ul>
          <p style={{ lineHeight: '1.8', marginBottom: '24px' }}>
            Folgende Daten können erhoben werden: Name, E-Mail-Adresse, Telefonnummer, Nachrichteninhalt.
          </p>

          <h2 style={{ fontFamily: 'Playfair Display, serif', color: 'var(--charcoal)', fontSize: '28px', marginBottom: '16px' }}>
            4. Zweck der Datenverarbeitung
          </h2>
          <p style={{ lineHeight: '1.8', marginBottom: '24px' }}>
            Die erhobenen Daten verwenden wir ausschliesslich für folgende Zwecke:
          </p>
          <ul style={{ marginBottom: '24px', paddingLeft: '24px' }}>
            <li style={{ marginBottom: '8px' }}>Beantwortung Ihrer Anfragen</li>
            <li style={{ marginBottom: '8px' }}>Versand von Newslettern (nur mit ausdrücklicher Einwilligung)</li>
            <li style={{ marginBottom: '8px' }}>Bereitstellung unserer Dienstleistungen</li>
            <li style={{ marginBottom: '8px' }}>Verbesserung unseres Angebots</li>
          </ul>

          <h2 style={{ fontFamily: 'Playfair Display, serif', color: 'var(--charcoal)', fontSize: '28px', marginBottom: '16px' }}>
            5. Weitergabe an Dritte
          </h2>
          <p style={{ lineHeight: '1.8', marginBottom: '24px' }}>
            Ihre Daten werden nicht an Dritte verkauft oder weitergegeben, es sei denn:
          </p>
          <ul style={{ marginBottom: '24px', paddingLeft: '24px' }}>
            <li style={{ marginBottom: '8px' }}>Sie haben ausdrücklich eingewilligt</li>
            <li style={{ marginBottom: '8px' }}>Dies ist zur Vertragserfüllung erforderlich</li>
            <li style={{ marginBottom: '8px' }}>Eine gesetzliche Verpflichtung besteht</li>
          </ul>

          <h2 style={{ fontFamily: 'Playfair Display, serif', color: 'var(--charcoal)', fontSize: '28px', marginBottom: '16px' }}>
            6. Cookies
          </h2>
          <p style={{ lineHeight: '1.8', marginBottom: '24px' }}>
            Diese Website verwendet Cookies nur für technisch notwendige Funktionen (z.B. Spracheinstellung). Diese Cookies werden lokal in Ihrem Browser gespeichert und enthalten keine personenbezogenen Daten.
          </p>

          <h2 style={{ fontFamily: 'Playfair Display, serif', color: 'var(--charcoal)', fontSize: '28px', marginBottom: '16px' }}>
            7. Datensicherheit
          </h2>
          <p style={{ lineHeight: '1.8', marginBottom: '24px' }}>
            Wir setzen technische und organisatorische Sicherheitsmassnahmen ein, um Ihre Daten gegen zufällige oder vorsätzliche Manipulationen, Verlust, Zerstörung oder gegen den Zugriff unberechtigter Personen zu schützen. Unsere Sicherheitsmassnahmen werden entsprechend der technologischen Entwicklung fortlaufend verbessert.
          </p>

          <h2 style={{ fontFamily: 'Playfair Display, serif', color: 'var(--charcoal)', fontSize: '28px', marginBottom: '16px' }}>
            8. Ihre Rechte
          </h2>
          <p style={{ lineHeight: '1.8', marginBottom: '24px' }}>
            Sie haben jederzeit das Recht auf:
          </p>
          <ul style={{ marginBottom: '24px', paddingLeft: '24px' }}>
            <li style={{ marginBottom: '8px' }}>Auskunft über Ihre gespeicherten Daten</li>
            <li style={{ marginBottom: '8px' }}>Berichtigung unrichtiger Daten</li>
            <li style={{ marginBottom: '8px' }}>Löschung Ihrer Daten</li>
            <li style={{ marginBottom: '8px' }}>Einschränkung der Datenverarbeitung</li>
            <li style={{ marginBottom: '8px' }}>Datenübertragbarkeit</li>
            <li style={{ marginBottom: '8px' }}>Widerspruch gegen die Datenverarbeitung</li>
          </ul>
          <p style={{ lineHeight: '1.8', marginBottom: '24px' }}>
            Zur Ausübung dieser Rechte kontaktieren Sie uns bitte unter: contact@lvluxury.ch
          </p>

          <h2 style={{ fontFamily: 'Playfair Display, serif', color: 'var(--charcoal)', fontSize: '28px', marginBottom: '16px' }}>
            9. Newsletter
          </h2>
          <p style={{ lineHeight: '1.8', marginBottom: '24px' }}>
            Wenn Sie unseren Newsletter abonnieren, verwenden wir Ihre E-Mail-Adresse ausschliesslich für den Versand von Informationen über neue Produkte und Angebote. Sie können den Newsletter jederzeit abbestellen, indem Sie uns eine E-Mail an contact@lvluxury.ch senden.
          </p>

          <h2 style={{ fontFamily: 'Playfair Display, serif', color: 'var(--charcoal)', fontSize: '28px', marginBottom: '16px' }}>
            10. Änderungen
          </h2>
          <p style={{ lineHeight: '1.8', marginBottom: '24px' }}>
            Wir behalten uns vor, diese Datenschutzerklärung jederzeit unter Beachtung der geltenden Datenschutzbestimmungen zu ändern. Die aktuelle Version ist stets auf unserer Website abrufbar.
          </p>

          <h2 style={{ fontFamily: 'Playfair Display, serif', color: 'var(--charcoal)', fontSize: '28px', marginBottom: '16px' }}>
            11. Kontakt
          </h2>
          <p style={{ lineHeight: '1.8', marginBottom: '24px' }}>
            Bei Fragen zum Datenschutz kontaktieren Sie uns bitte:<br /><br />
            E-Mail: contact@lvluxury.ch<br />
            Telefon: +41 41 543 36 77
          </p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
